import React, { useCallback } from 'react';
import { GuestScaffold } from 'layouts';
import { LoginForm } from 'components/Pages/Guest/Login';
import * as S from './styles';

export const LoginPage: React.FC = () => {
  const Header = useCallback(
    (): JSX.Element => (
      <S.Header>
        <S.Logo>
          <S.LogoImage src={require('assets/images/logo-cooperfibra.png')} />
        </S.Logo>
        <S.Title>
          Agendamento de entrada <br />e retirada de mercadorias.
        </S.Title>
        <S.Subtitle>
          Digite suas credenciais de acesso abaixo. <br /> Esqueceu sua senha?
          <S.ForgotMyPwsLink to="/esqueci-minha-senha">
            {' '}
            Redefinir senha
          </S.ForgotMyPwsLink>
        </S.Subtitle>
      </S.Header>
    ),
    []
  );

  return (
    <GuestScaffold>
      <S.PageContainer>
        <S.FormContainer>
          <Header />
          <LoginForm />
        </S.FormContainer>
        <S.ArtContainer />
      </S.PageContainer>
    </GuestScaffold>
  );
};
